import React from 'react';
import { Icon } from 'styleguide/Icons';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import { logout } from 'utils/logout';

export const LogoutButton = () => {
  return (
    <View style={{ flexDirection: 'row', justifyContent: 'flex-end', flex: 1 }}>
      <View onClick={() => logout({ isUserInitiated: true })} style={{ cursor: 'pointer' }}>
        <Icon style={{ paddingTop: Spacing.xs }} type="logout"></Icon>
      </View>
    </View>
  );
};
